import { PoweredBy } from "react-instantsearch-dom";
import "./PoweredBy.css";
export default PoweredBy;
